declare var app: any;
declare var JSZip: any;
declare var pako: any;
declare var _hmt: any;
declare var dataLayer: any;

import Vue from "vue";
import axios from "axios";
//多语言
import lang from "@/lang";
import VueI18n from "vue-i18n";
import edApi from "@/public/utils/edApi";
import viplimit from "@/public/utils/viplimit.js";
// import redPoint from "@/public/utils/RedPoint.vue";
import backTop from "@/public/components/back-top";
import redPoint from "@/public/utils/RedPoint.vue";
import EDMessage from "@/public/components/EDMessage/";
import EDModal from "@/public/components/EDModal/";
import EDTree from "@/public/components/EDTree/";
import { internal, urls } from "@/public/utils/env.js";
import VueTippy, { TippyComponent } from "vue-tippy";
import appConfig from "@/public/globalConfig";
import "tippy.js/themes/light.css";
// import { EDRAWMAX_PRODUCT_ENV, EDRAWMAX_PRODUCT_VIPLIMIT, EDRAWMAX_USE_SENSOR, EDRAWMAX_USE_BAIDUTRACK, EDRAWMAX_USE_GOOGLETRACK } from "@/env/"
import {
    EDRAWMAX_PRODUCT_ENV,
    EDRAWMAX_PRODUCT_VIPLIMIT,
    EDRAWMAX_USE_SENSOR,
    EDRAWMAX_USE_BAIDUTRACK,
    EDRAWMAX_USE_GOOGLETRACK,
    EDRAWMAX_OSSID,
} from "@/env";
import * as Sentry from "@sentry/vue";
import { ValidLang } from "@/app/utils/constant";
import { getHashString, openPlus } from "@/public/utils/tool";

declare var CreateNewFile: any;
export const appVersion = "14.1.4";
export let OSSAccessKeyId = EDRAWMAX_OSSID;
export let isMac = navigator.userAgent.indexOf("Mac") !== -1;
export let isLinux = String(navigator.platform).indexOf("Linux") > -1;
const isTestEnv = /dev.edrawmax/.test(location.host) || ~location.host.indexOf("10.") || ~location.host.indexOf("localhost");

/**
 * 设置全局配置 window.EDCONFIG
 */
function setEDConfig() {
    if (process.env.NODE_ENV === "development") {
        // const config = require("../../../public/EDConfig/default.json");
        // const config = require("../../../public/EDConfig/sdk.json");
        // const config = require("../../../public/EDConfig/edrawai.json");
        const config = require("../../../public/EDConfig/pptSdk.json");
        window.EDCONFIG = config;
    }

    // 生产环境，未设置全局配置时使用默认全局配置
    if (process.env.NODE_ENV === "production" && (typeof window.EDCONFIG !== "object" || Object.keys(window.EDCONFIG).length === 0)) {
        const defaultConfig = require("../../../public/EDConfig/default.json");
        window.EDCONFIG = defaultConfig;
    }
}
setEDConfig();

const $unZipFileName = function (string) {
    // 解密文件名
    let p = JSZip.pako || pako;
    return decodeURIComponent(p.inflateRaw(atob(string), { to: "string" }));
};

const initAccessId = () => {
    edApi()
        .getOssAccessID()
        .then((res) => {
            let id = res.data.data.access_id;
            if (id) {
                OSSAccessKeyId = id;
            }

            const host = res.data.data.host;
            if (host) {
                window["GLOBAL"].PUBLIC_OSS_HOST = host + "/";
            }
        });

    edApi()
        .getPriOssAccessID()
        .then((res) => {
            const host = res.data.data.host;
            if (host) {
                window["GLOBAL"].PRIVATE_OSS_HOST = host + "/";
                Vue.prototype.$edApi.fileOssAxIns.defaults.baseURL = window["GLOBAL"].PRIVATE_OSS_HOST;
            }
        });
};
initAccessId();

/**
 * sentry
 *
 */
const formatSentryRate = function (rate, defaultRate = 0) {
    const num = Number(rate);
    if (num >= 0 && num <= 1) {
        return num;
    }
    return defaultRate;
};

const ignoreErrors = [
    "UnhandledRejection",
    "Failed to read the 'contentDocument' property from 'HTMLIFrameElement'",
    'Blocked a frame with origin "https://www.edrawmax.com" from accessing a cross-origin frame.',
    "Fullscreen request denied",
    "Permissions check failed",
];

function initSentry() {
    if (process.env.NODE_ENV === "production" && window?.["GLOBAL"].SENTRY_DSN_URL) {
        Sentry.init({
            Vue,
            release: window["GLOBAL"].SENTRY_RELEASE || appVersion,
            dsn: window["GLOBAL"].SENTRY_DSN_URL,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                }),
            ],
            tracesSampleRate: formatSentryRate(window["GLOBAL"].SENTRY_TRACE_SAMPLERATE, 0.5),
            replaysSessionSampleRate: formatSentryRate(window["GLOBAL"].SENTRY_REPLAYS_SESSION_SAMPLERATE, 0.1),
            replaysOnErrorSampleRate: formatSentryRate(window["GLOBAL"].SENTRY_REPLAYS_ON_ERROR_SAMPLERATE, 1),
            ignoreErrors: ignoreErrors,
        });
        Sentry.setTag("deploy", EDRAWMAX_PRODUCT_ENV);
        Sentry.setTag("isPC", typeof (<any>window).qt !== "undefined" || typeof (<any>window).$qt !== "undefined");
    }
}

let utm_term = new URLSearchParams(location.search).get("utm_term") || "";
if (!utm_term && document.referrer && new URL(document.referrer).search) {
    utm_term = new URLSearchParams(new URL(document.referrer).search).get("utm_term");
}
window["openPlus"] = openPlus;

/**
 *
 * 神策
 * 埋点相关
 */
let appPid = 0;
const isPCView = !!window["$qt"]; // 客户端内嵌页面

// 作为SDK在EdrawAI环境上画布内埋点也上报上去。线上（edraw.ai），测试（dev-en.edraw.ai和dev.edraw.ai）
const isEdrawAI = location.origin.endsWith("edraw.ai");
const projectEdrawAI = location.origin.indexOf("dev") ? "UA_EdrawAI_web_test" : "UA_EdrawAI_web";
const serverUrlEdrawAI = `https://analytics.wondershare.cc:8106/sa?project=${projectEdrawAI}`;
const pidEdrawAI = 20032;

var sensors = null,
    bdTrack = null,
    googleTrack = null;
if (EDRAWMAX_USE_SENSOR && appConfig.isBuild && !isPCView && (!window.EDCONFIG.IS_SDK || isEdrawAI)) {
    // 开发环境去除神策埋点，如需测试自行打开
    appPid = internal ? 9277 : 5868;
    if (new URLSearchParams(location.search).get("channel") == "adonline") {
        appPid = internal ? 20061 : 20062;
    }
    let scuser = localStorage.getItem("scuser") || "new";
    sensors = require("sa-sdk-javascript");
    const server_url = isTestEnv
        ? "https://analytics.wondershare.cc:8106/sa?project=PC_test_project"
        : `https://analytics.wondershare.cc:8106/sa?project=UA_EdrawMax_web`;
    sensors.init({
        server_url: isEdrawAI ? serverUrlEdrawAI : server_url,
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: "beacon",
        show_log: false,
        heatmap: {
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: "default",
            //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: "not_collect",
        },
    });
    let lang = "cn";
    if (!internal) {
        let localLang = localStorage.getItem("lang");
        lang = localLang || "en";
        let nativeLang = getHashString("lang");
        if (ValidLang.includes(nativeLang)) {
            lang = nativeLang;
            localStorage.setItem("lang", lang);
        }
    }
    let plang = lang === "zh" ? "cn" : lang;
    sensors.registerPage({
        tid: "UA-EdrawMax-Web",
        pid: isEdrawAI ? pidEdrawAI : appPid,
        uid: 0,
        pver: appVersion,
        oszone: 0,
        pbrand: "Wondershare",
        psource: `${isEdrawAI ? pidEdrawAI : appPid}`,
        plang: plang,
        user: scuser, //|| 'new'
        refer_url: document.referrer,
        last_selfutm_term: utm_term,
        // $ip: '',
        // osbit: 0,
        // $os_version: '',
        // ostype: '',
        // oslang: '',
        // $lib_version: '',
        // $country: '',
    });
    sensors.quick("autoTrack"); //用于采集 $pageview 事件。
    localStorage.setItem("scuser", "old");
} else {
    sensors = {
        track: () => {},
        registerPage: () => {},
        quick: () => {},
    };
}
if (EDRAWMAX_USE_BAIDUTRACK && !window.EDCONFIG.IS_SDK) {
    bdTrack = function (category, action, opt_label) {
        if (this.internal) {
            Array.isArray(_hmt) && _hmt.push(["_trackEvent", category, action, opt_label]);
        } else {
            // dataLayer.push({
            //     "event": action,
            //     'event_category': category,
            //     'event_label': opt_label
            // })
        }
    };
} else {
    bdTrack = () => {};
}
if (EDRAWMAX_USE_GOOGLETRACK && !window.EDCONFIG.IS_SDK) {
    googleTrack = function (action, label) {
        let win: any = window;
        let eventName = "";
        if (this.internal) {
            eventName = "YT_Edrawmax_CN";
        } else {
            eventName = "YT_Edrawmax_overseas";
        }
        win.dataLayer &&
            Array.isArray(win.dataLayer) &&
            win.dataLayer.push({
                event: eventName,
                hitTimeStamp: "" + new Date().getTime(),
                eventAction: action,
                eventLable: label,
            });
    };
} else {
    googleTrack = () => {};
}

const EventBus = new Vue();
Object.assign(EventBus, {
    $asyncEmit: function (name: any, payload: any) {
        return new Promise((resolve, reject) => {
            this.$emit(name, { payload, resolve, reject });
        });
    },
});
Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus;
        },
    },
});

Vue.use(EDMessage);
Vue.use(VueI18n);
Vue.use(EDModal);
Vue["locale"] = () => {};

Vue.component("ed-back-top", backTop);
Vue.component("ed-tree", EDTree);
Vue.use(VueTippy, {
    directive: "tippy", // => v-tippy
    flipDuration: 0,
    animation: "fade",
    theme: "max",
    animateFill: false,
    delay: [300, 0],
    duration: [100, 0],
    a11y: false,
    onShow(instance) {
        if (instance && !instance.props.content) {
            return false;
        }
    },
    // onShown(instance) {
    //     console.log(instance, '>>>123')
    // }
});
Vue.component("tippy", TippyComponent);

let isInclowdz = location.href.includes("inclowdz");
sessionStorage.setItem("isInclowdz", isInclowdz ? "1" : "0");

let plugin = {};
plugin["install"] = function (Vue) {
    Vue.mixin({
        computed: {
            config() {
                return this.$store && this.$store.getters.userConfig;
            },
            internal() {
                return internal;
            },
            urls() {
                return urls;
            },
            vip() {
                // return true
                if (this.isPrivate) {
                    return true;
                }
                if (this.isPC) {
                    return this.$store.state.pcVip;
                } else {
                    // 旧逻辑中 $v_ 变量疑似重复无用，待观察后删除相关代码（$v_ 变量、vipState 等）
                    // return this.$store.state.publicStore.vip && app && typeof app.$v_ != 'undefined' && app.$v_;
                    return this.$store.state.publicStore.vip;
                }
            },
            fuser() {
                return !!this.$store.state.publicStore.fuser;
            },
            lang() {
                return this.$store && this.$store.state.publicStore.lang;
            },
            appVersion() {
                return appVersion;
            },
            appPid() {
                return appPid;
            },
            isPlugin() {
                return this.appEnv == "plugin" || this.appEnv == "board";
            },
            isBoard() {
                return this.appEnv == "board";
            },
            appEnv() {
                return EDRAWMAX_PRODUCT_ENV;
            },
            isPrivate() {
                // 私有化环境 (企业微信算是特殊的私有化环境)
                return this.appEnv == "private" || this.appEnv == "workwx";
            },
            isWorkwx() {
                // 企业微信环境 (包含私有化环境，两者需区分判断时企微需前置条件)
                return this.appEnv == "workwx";
            },
            isTeamsApp() {
                // teams环境
                return this.appEnv == "teamsapp";
            },
            isFullCouldSpace() {
                let userInfo = this.$store?.state?.userInfo || this.$store?.state?.user?.userInfo;
                if (userInfo && userInfo.used_storage >= userInfo.max_storage) {
                    return true;
                } else {
                    return false;
                }
            },
            OSSAccessKeyId() {
                return OSSAccessKeyId;
            },
            pid() {
                return this.$store && this.$store.state.publicStore.pid;
            },

            isTestEnv() {
                return isTestEnv;
            },
            utm_term() {
                return utm_term;
            },
        },
        components: {
            redPoint,
        },
        watch: {
            lang(newVal) {
                this.$i18n.locale = newVal;
            },
        },
        methods: {
            isDarkTheme() {
                return window.EDCONFIG.DEFAULT_THEME === "dark";
            },
        },
    });
    Vue.prototype.sensors = sensors;
    Vue.prototype.$edApi = edApi();
    Vue.prototype.$track = bdTrack;
    Vue.prototype.$gaTrack = googleTrack;
    Vue.prototype.$decFileName = function (name: string) {
        return name.replace(/\&/g, (e) => {
            if (e == "&") {
                return "%26";
            }
        });
    };
    Vue.prototype.$validateLogin = function (showLogin = true) {
        let userInfo = this.$store.state.userInfo;
        if (!userInfo && this.$store.state.user) {
            userInfo = this.$store.state.user.userInfo;
        }
        if (this.isPC && userInfo && showLogin && !userInfo.islogin) {
            (<any>window).$qt.jsCallUserLogin();
            return false;
        } else if (!this.isPC && isInclowdz) {
            if (!userInfo) {
                showLogin && this.$bus.$emit("inclowdLogin");
                return false;
            } else {
                return true;
            }
        } else if (!this.isPC) {
            if (!userInfo || !userInfo.token) {
                showLogin && this.$bus.$emit("login");
                return false;
            } else {
                return true;
            }
        }
        return true;
    };
    Vue.prototype.$recFileName = function (name: string) {
        return name.replace(/%26/g, (e) => {
            if (e == "%26") {
                return "&";
            }
        });
    };
    Vue.prototype.$checkAuth = function (
        param: {
            type: string;
            libraryName?: string;
            buyTrigger: string;
            pcParams?: {
                newUpgrade: number;
                upgrade: number;
            };
        },
        showDialog: string = "upgrade"
    ): boolean {
        // 检测vip限制，唤起会员权益过渡页
        if (this.isPlugin) return true;
        if (!EDRAWMAX_PRODUCT_VIPLIMIT) {
            return true;
        }
        param = Object.assign(param, {
            vip: this.vip,
        });
        let limit = viplimit(param);
        if (param.type == "cloudSpaceVIP") {
            limit = "cloudSpaceVIP";
        }
        if (limit != "pass") {
            let triggerName = param.buyTrigger || "others";
            let { newUpgrade = 0, upgrade = 0 } = param.pcParams || {};
            if (showDialog == "upgrade") {
                if (this.isPC) {
                    (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger(triggerName);
                    (<any>window).$qt.jsCallUpgradeToPremium && (<any>window).$qt.jsCallUpgradeToPremium(upgrade);
                    (<any>window).$qt.jsCallNewUpgradeToPremium && (<any>window).$qt.jsCallNewUpgradeToPremium(newUpgrade);
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "upgradeTrigger",
                        data: triggerName,
                    });
                    // 这个顺序不能调，sdk 不用 max 的会员升级弹窗
                    if (window.EDCONFIG.IS_SDK) {
                        this.$openBuyPage(triggerName);
                        return;
                    }
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: limit,
                    });
                    this.$store.commit("toPublicStatus", {
                        type: "libraryName",
                        data: param.libraryName,
                    });
                }
            }
            if (showDialog == "buyframe") {
                // 调用 $checkAuth 直接展示内购页时，param 需要传入埋点名称
                this.$openBuyPage(triggerName);
            }
            return false;
        }
        return true;
    };
    Vue.prototype.$zipFileName = function (string) {
        // 加密文件名
        let p = JSZip.pako || pako;
        return btoa(p.deflateRaw(encodeURIComponent(string), { level: 6, to: "string" }));
    };
    Vue.prototype.$unZipFileName = $unZipFileName;
    Vue.prototype.$cleanUrlParams = function (key) {
        // 清除url字段
        let reg = new RegExp(`[\&|\?]${key}\=[^\&]*`);
        let urlData = this.$unZipFileName(window.location.search.substr(1));
        let tempUrl = window.location.origin + appConfig["sourcePath"] + "app.html?" + this.$zipFileName(urlData.replace(reg, "")) + location.hash;
        history.replaceState(history.state, "", tempUrl);
    };
    Vue.prototype.$pcTrack = function (jsonData) {
        (<any>window).$qt && (<any>window).$qt.jsCallUploadData && (<any>window).$qt.jsCallUploadData(jsonData);
    };
    Vue.prototype.$changLang = function (lang: string): string {
        switch (lang) {
            case "zh": {
                lang = "zh_cn";
                break;
            }
            case "tw": {
                lang = "sch";
                break;
            }
            case "jp": {
                lang = "jp";
                break;
            }
            case "de": {
                lang = "de";
                break;
            }
            case "fr": {
                lang = "fr";
                break;
            }
            case "es": {
                lang = "es";
                break;
            }
            case "it": {
                lang = "it";
                break;
            }
            case "pt": {
                lang = "pt";
                break;
            }
            case "kr":
            case "ko": {
                lang = "ko";
                break;
            }
            case "ru": {
                lang = "ru";
                break;
            }
            default: {
                lang = "en_us";
            }
        }
        return lang;
    };

    Vue.prototype.$openBuyPage = function (triggerName: string = "others", suffix = "", data?: any) {
        if (window.EDCONFIG.IS_SDK) {
            let publicTrigger = this.$store.state.publicStore.upgradeTrigger;
            if (
                triggerName === "library" ||
                triggerName === "exportPPT" ||
                triggerName === "versionCreate" ||
                triggerName === "versionNew" ||
                triggerName === "versionRecover" ||
                triggerName === "versionDelete" ||
                triggerName === "versionOpen" ||
                triggerName === "formulaEditor" ||
                triggerName === "printNomark" ||
                triggerName === "playSlider" ||
                triggerName === "Replace" ||
                triggerName === "symbolsFloatingWindow" ||
                triggerName === "removeGrid" ||
                (triggerName !== "others" && !publicTrigger)
            ) {
                publicTrigger = triggerName;
            }

            this.sdkApp.promisePostMessage("SHOW_BUY_COMPONENT", {
                triggerName: publicTrigger,
                data,
            });
            return;
        }

        // 唤起内购页
        let asd = {
            en: this.$store.state.isAd ? "https://www.edrawmax.com/ad/pricing-new.html" : "https://www.edrawmax.com/pricing-new/online-pa.html",
            de: "https://www.edrawsoft.com/de/pricing-edrawmax.html",
            jp: "https://www.edrawsoft.com/jp/pricing-edrawmax.html",
            es: "https://www.edrawsoft.com/es/pricing-edrawmax.html",
            fr: "https://www.edrawsoft.com/fr/pricing-edrawmax.html",
            it: "https://www.edrawsoft.com/it/pricing-edrawmax.html",
            pt: "https://www.edrawsoft.com/pt/pricing-edrawmax.html",
            tw: "https://www.edrawsoft.com/tw/pricing-edrawmax.html",
            kr: "https://www.edrawsoft.com/kr/pricing-edrawmax.html",
        };
        let url = asd[this.lang] || "https://www.edrawmax.com/pricing-new/online-pa.html";
        if ([5517, 5518].includes(this.pid)) {
            url = "https://www.edrawsoft.com/ad/pricing-edrawmax.html";
        }
        url = `${url}?${suffix}`;
        if (this.isPC) {
            (<any>window).$qt.jsCallUpdateUpgradeTrigger && (<any>window).$qt.jsCallUpdateUpgradeTrigger(triggerName);
            this.internal ? (<any>window).$qt.jsCallOpenWebBuyDialog(`&${suffix}`) : (<any>window).$qt.jsCallOpenUrl(url);
        } else {
            if (this.internal) {
                this.$store.commit("toPublicStatus", {
                    type: "showBuyframe",
                    data: true,
                });
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: triggerName,
                });
            } else {
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: triggerName,
                });
                window.open(url);
            }
        }
    };

    Vue.prototype.$openFile = openFile;
};
Vue.use(plugin as any);

const i18n = new VueI18n({
    locale: "zh", // set locale
    messages: lang, // set locale messages
    silentTranslationWarn: true,
    fallbackLocale: "en",
});

function openFile(obj) {
    let { params, fileType, suffix, checkLimit, limitRange, limitCallback, vip, from = "home", isFullCouldSpace } = obj;
    let userInfo = this.$store.getters.apiParam;
    let checkLimitFunc = () => {
        if (checkLimit) {
            return new Promise((rs, rj) => {
                this.$edApi.getUserLimit({ id: userInfo.id, token: userInfo.token, platform: limitRange }).then((res) => {
                    let wmfree = res.data.wmfree_limit;
                    let wmlist = res.data.wmfrees;
                    let num = res.data.limit;
                    this.$store.commit("setState", {
                        type: "limitFileNum",
                        data: num,
                    });
                    this.$store.commit("setState", {
                        type: "limitFileNowFileNum",
                        data: res.data.num + 1, // ? 存疑，是否会创建失败
                    });
                    if (from == "home" && res.data.num >= num && !vip && this.$store.state.limitFileModalFlag) {
                        this.$store.commit("setState", {
                            type: "limitFileModalFlag",
                            data: false,
                        });
                        limitCallback && limitCallback("showLimitModal");
                        rj("");
                    } else if (wmfree == 0 && !vip && fileType == "storeTemplate" && params.member) {
                        // 非会员使用会员模版
                        limitCallback && limitCallback("limitVipTemplate");
                        rj("");
                    } else if (wmfree > 0 && !vip && fileType == "storeTemplate" && params.member) {
                        if (wmfree > wmlist.length || wmlist.includes(params.workId)) {
                            if (from == "home") {
                                this.$store.commit("setState", {
                                    type: "limitFileModalFlag",
                                    data: true,
                                });
                            }
                            rs(null);
                        } else {
                            limitCallback && limitCallback("limitVipTemplate");
                            rj("");
                        }
                    } else if (res.data.is_over_limit) {
                        limitCallback && limitCallback();
                        rj(res.data.is_over_limit);
                    } else if (isFullCouldSpace) {
                        if (!vip) {
                            limitCallback && limitCallback("showLimitCloudSpace");
                        } else {
                            limitCallback && limitCallback("showLimitCloudSpaceVIP");
                        }
                    } else {
                        if (from == "home") {
                            this.$store.commit("setState", {
                                type: "limitFileModalFlag",
                                data: true,
                            });
                        }
                        rs(null);
                    }
                });
            });
        } else {
            return Promise.resolve();
        }
    };

    let setOpenTabs = (path) => {
        let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
        if (!openTabs.includes(path)) {
            openTabs.push(path);
        }
        localStorage.setItem("openTabs", JSON.stringify(openTabs));
    };

    let beforeOpen = (type) => {
        // 需预处理请求后才有具体的链接
        let createEmptyFile = () => {
            // NewPage.vue -- 创建空白模板
            let { newFileName, libs, currentPath, folderId } = params;
            currentPath = currentPath ? currentPath : "";
            let getCreateTime = () => {
                let datetime = new Date();
                let year = datetime.getFullYear();
                let month: number | string = datetime.getMonth() + 1; //js从0开始取
                let date: number | string = datetime.getDate();
                let hour: number | string = datetime.getHours();
                let minutes: number | string = datetime.getMinutes();
                let second: number | string = datetime.getSeconds();

                if (month < 10) {
                    month = "0" + month;
                }
                if (date < 10) {
                    date = "0" + date;
                }
                if (hour < 10) {
                    hour = "0" + hour;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (second < 10) {
                    second = "0" + second;
                }

                let time = year + "/" + month + "/" + date + " " + hour + ":" + minutes + ":" + second;
                return time;
            };
            let dataURLtoBlob = () => {
                let dataurl =
                    "data:image/png;base64,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";
                var arr = dataurl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            };
            let htmlEncodeByRegExp = (str) => {
                var temp = "";
                if (str.length == 0) return "";
                temp = str.replace(/&/g, "&amp;");
                temp = temp.replace(/</g, "&lt;");
                temp = temp.replace(/>/g, "&gt;");
                temp = temp.replace(/\s/g, "&nbsp;");
                temp = temp.replace(/\'/g, "&#39;");
                temp = temp.replace(/\"/g, "&quot;");
                return temp;
            };
            let createFileTool = (uGrid) => {
                return new Promise((rs, rj) => {
                    let index = this.internal ? 0 : 1,
                        docName = `${newFileName}.eddx`,
                        screenW = window.screen.width * window.devicePixelRatio,
                        screenH = window.screen.height * window.devicePixelRatio,
                        createTime = getCreateTime(),
                        creater = htmlEncodeByRegExp(userInfo.nickName),
                        maxVersion = this.isPC && this.$store ? this.$store.state.pcVersion : appVersion;
                    let createTool = new CreateNewFile(index, docName, screenW, screenH, createTime, creater, maxVersion, libs, vip, uGrid);
                    createTool.createFile().then((e) => {
                        let obj = {
                            name: newFileName,
                            size: e[0].size,
                            file: e[0],
                        };
                        let path = `${userInfo.userName}/Personal/${currentPath}${obj.name}.eddx`;
                        let params = Object.assign(
                            { obj: path, size: obj.size },
                            {
                                id: userInfo.id,
                                token: userInfo.token,
                                cover: false,
                            }
                        );
                        if (this.isPrivate) {
                            params = Object.assign(params, {
                                name: newFileName,
                                platform: "web",
                                folder_id: folderId,
                            });
                        }
                        this.$edApi.getCloudFileSign(params).then((res) => {
                            let list = [];
                            let filePath = res.data.obj;
                            newFileName = filePath.split("/")?.pop()?.split(".")?.[0] || newFileName;
                            let sign = res.data.sign;
                            let exp = res.data.exp;
                            let ossParams = {
                                url: filePath,
                                exp,
                                sign,
                                file: obj.file,
                                contentType: "application/octet-stream",
                            };
                            let img_sign = res.data.img_up_sign;
                            let imageOssParams = {
                                url: res.data.img,
                                exp,
                                sign: img_sign,
                                file: dataURLtoBlob(),
                                contentType: "image/png",
                            };
                            list.push(this.$edApi.uploadOSSFile(ossParams));
                            list.push(this.$edApi.uploadOSSFile(imageOssParams));
                            Promise.all(list)
                                .then(() => {
                                    let userTaskFlag = this.$store.state.publicStore.createFileTaskFlag;
                                    let fileObj = `obj=${filePath}&name=${newFileName}${suffix}`;
                                    let fileUrl = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(fileObj);
                                    if (userTaskFlag) {
                                        fileUrl += "#fileTask";
                                    }
                                    rs({
                                        url: fileUrl,
                                        obj: filePath,
                                    });
                                    if (userTaskFlag && !window["$qt"]) {
                                        // 区分pc环境
                                        // 新手任务
                                        this.$store.commit("toPublicStatus", {
                                            type: "createFileTaskFlag",
                                            data: false,
                                        });
                                        this.$bus.$emit("changeUserTaskStatus", {
                                            id: 2,
                                            status: 1,
                                            noAnimation: true,
                                        });
                                    }
                                    setOpenTabs(filePath);
                                })
                                .catch((e) => {
                                    rj("createFile Fail");
                                });
                        });
                    });
                });
            };
            return checkLimitFunc().then(() => {
                return this.$edApi
                    .getUserPrefer({ id: userInfo.id })
                    .then((result) => {
                        return createFileTool(!!result.data.showGrid);
                    })
                    .catch((e) => {
                        return createFileTool(false);
                    });
            });
        };

        let cloneCustomTemplate = () => {
            // NewPage.vue -- 克隆用户自定义模板
            return checkLimitFunc().then(() => {
                return new Promise((rs, rj) => {
                    this.$edApi.useCustomTemplateSign(params).then((res) => {
                        let fileName = "";
                        if (this.isPrivate) {
                            fileName = "&name=" + res.data.data.name;
                        } else {
                            fileName = "&name=" + res.data.data.object.match(/[^\/]*(?=\.eddx)/i)[0];
                        }
                        let fileObj = `obj=${res.data.data.object}${fileName}${suffix}`;
                        let fileUrl = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(fileObj);
                        setOpenTabs(res.data.data.object);
                        rs({
                            url: fileUrl,
                            obj: res.data.data.object,
                        });
                    });
                });
            });
        };

        let cloneNewPageTemplate = () => {
            // NewPage.vue -- 克隆新建页模板
            return checkLimitFunc().then(() => {
                return new Promise((rs, rj) => {
                    this.$edApi
                        .useTemplate({
                            id: userInfo.id,
                            token: userInfo.token,
                            tempId: params.template_id,
                            platform: limitRange,
                        })
                        .then((res) => {
                            if (res.data.status == "success") {
                                let fileName = "";
                                if (this.isPrivate) {
                                    fileName = "&name=" + res.data.data.name;
                                } else {
                                    fileName = "&name=" + res.data.data.obj.match(/[^\/]*(?=\.eddx)/i)[0];
                                }
                                let workId = `&cloneID=${params.template_id}`;
                                let fileObj = `obj=${res.data.data.obj}${fileName}${workId}${suffix}`;
                                let fileUrl = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(fileObj);
                                setOpenTabs(res.data.data.obj);
                                rs({
                                    url: fileUrl,
                                    obj: res.data.data.obj,
                                    status: "succ",
                                });
                            } else if (res.data.status == "error") {
                                rs({
                                    status: "fail",
                                    msg: res.data.msg,
                                });
                            }
                        });
                });
            });
        };

        let cloneStoreTemplate = () => {
            // 克隆社区模板
            return checkLimitFunc().then(() => {
                return new Promise((rs, rj) => {
                    this.$edApi
                        .cloneFile(params)
                        .then((data) => {
                            let obj = data.object;
                            let fileName = "&name=" + obj.match(/[^\/]*(?=\.eddx)/i)[0];
                            let workId = `&cloneID=${params.workId}`;
                            let fileObj = `obj=${obj}${fileName}${workId}${suffix}`;
                            let fileUrl = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(fileObj);
                            setOpenTabs(obj);
                            rs({
                                url: fileUrl,
                                obj: obj,
                                status: "succ",
                            });
                        })
                        .catch((err) => {
                            rs({
                                status: "fail",
                                msg: err,
                            });
                        });
                });
            });
        };

        let paidTemplate = () => {
            // 克隆社区付费模板，存在异步打开窗口问题
            return checkLimitFunc().then(() => {
                return new Promise((rs, rj) => {
                    this.$edApi
                        .cloneFile(params)
                        .then((data) => {
                            let obj = data.object;
                            let fileName = "&name=" + obj.match(/[^\/]*(?=\.eddx)/i)[0];
                            let workId = `&cloneID=${params.workId}`;
                            let fileObj = `obj=${obj}${fileName}${workId}${suffix}`;
                            let fileUrl = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(fileObj);
                            rs({
                                url: fileUrl,
                                obj: obj,
                                status: "succ",
                            });
                        })
                        .catch((error) => {
                            rj({
                                status: "fail",
                                msg: error,
                            });
                        });
                });
            });
        };

        let cloneStoreSymbol = () => {
            // 使用社区符号模板
            return new Promise((rs, rj) => {
                this.$edApi
                    .cloneFile(params)
                    .then((data) => {
                        let obj = data.object;
                        let fileName = "&name=" + obj.match(/[^\/]*(?=\.edt)/i)[0];
                        let fileObj = `obj=${obj}${fileName}${suffix}`;
                        let fileUrl = window.location.origin + appConfig.sourcePath + "app.html?" + this.$zipFileName(fileObj);
                        setOpenTabs(obj);
                        rs({
                            url: fileUrl,
                            obj: obj,
                            table_id: data.table_id,
                            status: "succ",
                        });
                    })
                    .catch((err) => {
                        rs({
                            status: "fail",
                            msg: err,
                        });
                    });
            });
        };

        switch (type) {
            case "emptyFile":
                return createEmptyFile();
            case "customTemplate":
                return cloneCustomTemplate();
            case "newPageTemplate":
                return cloneNewPageTemplate();
            case "storeTemplate":
                return cloneStoreTemplate();
            case "paidTemplate":
                return paidTemplate();
            case "storeSymbol":
                return cloneStoreSymbol();
            case "checkLimit":
                return checkLimitFunc();
        }
    };

    let openExit = () => {};

    let importFile = () => {};

    let openLink = (url) => {
        window.open(url);
    };

    return beforeOpen(fileType);
}

export { Vue, i18n, initSentry };
